import React, { useMemo } from 'react';

import { Flex, Group, ThemeIcon } from '@mantine/core';
import { DateTime } from 'luxon';
import { IconCalendar, IconClock } from 'ui-icons';

import { cx } from '../../../../Provider/Provider';
import { Text } from '../../../../Typography';
import { SelectableCard } from '../../cards/SelectableCard/SelectableCard';
import classes from './EventCard.module.css';

export interface EventCardProps extends React.ComponentProps<'button'> {
  thumbnailSrc?: string;
  imageSrc?: string;
  name?: string;
  start_date?: string;
  end_date?: string;
  onClick?: () => void;
  isColumn?: boolean;
}

const EventCardDates = ({ start_date, end_date }: { start_date?: string; end_date?: string }) => {
  const isMultiDate = useMemo(() => {
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    return !DateTime.fromISO(start_date).hasSame(DateTime.fromISO(end_date), 'day');
  }, [start_date, end_date]);

  const startDate = useMemo(() => {
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    return DateTime.fromISO(start_date).toFormat('ccc, LLL d');
  }, [start_date]);

  const endDate = useMemo(() => {
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    return DateTime.fromISO(end_date).toFormat('ccc, LLL d');
  }, [end_date]);

  const eventTime = useMemo(() => {
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    const startTime = DateTime.fromISO(start_date)
      .toLocaleString(DateTime.TIME_SIMPLE)
      .replace(' AM', 'am')
      .replace(' PM', 'pm');
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    const endTime = DateTime.fromISO(end_date)
      .toLocaleString(DateTime.TIME_SIMPLE)
      .replace(' AM', 'am')
      .replace(' PM', 'pm');
    // @ts-expect-error - TODO: Fix this ts issue DISTE-1408
    const timezone = DateTime.fromISO(start_date).toFormat('ZZZZ');

    return `${startTime} - ${endTime} ${timezone}`;
  }, [end_date, start_date]);

  if (!start_date || !end_date) {
    return null;
  }

  return (
    <Flex className={classes.EventCard__info}>
      {isMultiDate ? (
        <Group className={classes.EventCard__infoItem} wrap="nowrap">
          <ThemeIcon c="gray.4" variant="transparent" size="16">
            <IconCalendar />
          </ThemeIcon>
          <Text fz="xs" c="gray.8">
            {`${startDate} - ${endDate}`}
          </Text>
        </Group>
      ) : (
        <>
          <Group className={classes.EventCard__infoItem} wrap="nowrap">
            <ThemeIcon c="gray.4" variant="transparent" size="16">
              <IconCalendar />
            </ThemeIcon>
            <Text fz="xs" c="gray.8">
              {startDate}
            </Text>
          </Group>
          <Group className={classes.EventCard__infoItem} wrap="nowrap">
            <ThemeIcon c="gray.4" variant="transparent" size="16">
              <IconClock />
            </ThemeIcon>
            <Text fz="xs" c="gray.8">
              {eventTime}
            </Text>
          </Group>
        </>
      )}
    </Flex>
  );
};

const EventCard = ({
  thumbnailSrc,
  imageSrc,
  name,
  start_date,
  end_date,
  onClick,
  isColumn = true,
}: EventCardProps) => {
  return (
    <SelectableCard
      imageSrc={imageSrc}
      thumbnailSrc={thumbnailSrc}
      title={name || 'Your Event'}
      description={<EventCardDates start_date={start_date} end_date={end_date} />}
      isColumn={isColumn}
      onClick={onClick}
      className={cx(classes.EventCard, { [classes['EventCard--column']]: isColumn })}
    />
  );
};

export { EventCard };
